import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import _ from "lodash";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Filters from "../../common/reports/Filters";
import { LIKE} from "../../common/reports/reportConstants";
import { createFilterParam } from "../../common/reports/reportUtils";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import TextInput from "../../framework/TextInput";
import { isEmpty } from "../../utils/utils";
import NumberInput from "../../framework/NumberInput";

const ProfessionMasterReportFilter = ({
  reportRef,
  onFilterShow,
  applyFilterOnMount = true,
}) => {
  const [professionName, setProfessionName] = useState("");

  const [orderBy] = useState([
    { fieldName: "professionName", orderType: "asc" },
  ]);
  const [limit, setLimit] = useState(100);
  const apr_filter_profession_master_name = useRef();
  const applyFilterRef = useRef();
  const { setCurrentComponent } = useContext(GlobalContext);
  const applyFilterHandler = useCallback(
    (isFilterChanged = false) => {
      let filters = [];
      let result = {};
      if (!isEmpty(professionName)) {
        filters.push(
          createFilterParam("name", professionName, "string", LIKE)
        );
      }
      if (isFilterChanged) {
        result.filters = filters;
      }
      if (!isEmpty(limit)) {
        result.limit = limit;
      }
      reportRef.current?.applyFilters(result);
    },
    [professionName, reportRef, limit]
  );
  let debounce = useCallback(
    _.debounce(() => {
      applyFilterHandler();
    }, 300),
    []
  );
  const filterListener = useCallback((event) => {
    const key = event.key.toLowerCase();
    const ctrl = event.ctrlKey;
    if (ctrl && key === "enter") {
      return applyFilterRef.current.click();
    }
  }, []);

  const filterContent = (
    <>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="apr_filter_profession_master_name"
            label="Profession Name"
            ref={apr_filter_profession_master_name}
            onFocus={() =>
              setCurrentComponent("apr_filter_profession_master_name")
            }
            value={professionName}
            onChange={(e) => {
              setProfessionName(e.target.value);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "apr_filter_limit",
                down: "apr_filter_profession_master_name",
                right: "apr_filter_limit",
                left: "apr_filter_profession_master_name",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <NumberInput
            label="Limit"
            id="apr_filter_limit"
            value={limit}
            onFocus={() => setCurrentComponent("apr_filter_limit")}
            onValueChange={(values, e) => {
              setLimit(values.floatValue);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "apr_apply_filter_button",
                left: "apr_filter_profession_master_name",
                down: "apr_filter_profession_master_name",
                right: "apr_apply_filter_button",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );
  const filterFooter = (
    <>
      <FilterGroup>
        <FilterItem>
          <Button
            id="apr_apply_filter_button"
            label="Apply"
            ref={applyFilterRef}
            endIcon={<Shortcut keys={["Ctrl", "Enter"]} />}
            onClick={() => {
              applyFilterHandler(true);
            }}
            markers={JSON.stringify({
              up: "apr_apply_filter_button",
              left: "apr_filter_limit",
              right: "apr_apply_filter_button",
              down: "apr_filter_limit",
            })}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );

  useEffect(() => {
    if (onFilterShow) {
      apr_filter_profession_master_name?.current.focus({ preventScroll: true });
    }
  }, [onFilterShow]);
  useEffect(() => {
    if (onFilterShow) document.addEventListener("keyup", filterListener, false);
    return () => {
      document.removeEventListener("keyup", filterListener, false);
    };
  }, [filterListener, onFilterShow]);
  useEffect(() => {
    if (applyFilterOnMount) debounce();
    return () => {
      debounce.cancel();
    };
  }, [applyFilterOnMount, debounce]);

  return <Filters filterContent={filterContent} filterFooter={filterFooter} />;
};

export default ProfessionMasterReportFilter;
